module.exports = __webpack_public_path__ + "static/media/checkmark.e62342cd.svg";